// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementLocationsAppsResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      type: string,
      image_url: string,
      geofences_enabled: boolean,
      sdk_version_supports_geofences: boolean,
    })
  ),
});
